"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIcon = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const GenericIcon_1 = require("./GenericIcon");
const createIcon = (path) => {
    const Component = (props) => (react_1.default.createElement(GenericIcon_1.GenericIcon, Object.assign({ path: path }, props)));
    return Component;
};
exports.createIcon = createIcon;
//# sourceMappingURL=createIcon.js.map